export default {
    hasListener : false,
    mediaQueries : [
        // function(watch){
        //     if (window.matchMedia('(min-width: 1440px)').matches) {
        //         console.log(1440);
        //         watch.minWidth = 1440;
        //     }
        // },
    ],
    watch : {
        // minWidth : 0,
    },
    addListener(){
        if (this.hasListener === false) {
            this.hasListener = true;
            window.addEventListener('resize', this.resizeHandler.bind(this));
            this.resizeHandler();
        }
    },
    removeListener(){
        if (this.hasListener === true) {
            this.hasListener = false;
            window.removeEventListener('resize', this.resizeHandler.bind(this));
        }
    },
    resizeHandler(){
        for (let i = 0; i < this.mediaQueries.length; i++) {
            this.mediaQueries[i](this.watch);
        }
    },
}



//////////////////
// WEBPACK FOOTER
// ./public/js/services/cssMediaQueryHelper.js
// module id = 44
// module chunks = 0